(function () {
  "use strict";
  var kok = document.getElementById("rh-danisman");
  if (!kok || !kok.dataset.url) return;
  var URL_BOT = kok.dataset.url.replace(/\/$/, "");
  var WA = kok.dataset.wa;
  var SABLON = kok.dataset.sablon;
  var SAYFA = kok.dataset.sayfa;
  var OTURUM_ANAHTAR = "rh_danisman_oturum", MESAJ_ANAHTAR = "rh_danisman_mesajlar", ACIK_ANAHTAR = "rh_danisman_acik";
  var SAGLIK_ANAHTAR = "rh_danisman_saglik", SAGLIK_SURE = 5 * 60 * 1000;

  function oku(k, v) { try { var x = localStorage.getItem(k); return x ? JSON.parse(x) : v; } catch (e) { return v; } }
  function yaz(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function saglikOku() { try { var x = sessionStorage.getItem(SAGLIK_ANAHTAR); return x ? JSON.parse(x) : null; } catch (e) { return null; } }
  function saglikYaz(ok) { try { sessionStorage.setItem(SAGLIK_ANAHTAR, JSON.stringify({ ok: ok, zaman: Date.now() })); } catch (e) {} }
  function uuid() {
    var ham = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
    return ham.replace(/[^A-Za-z0-9-]/g, "");
  }
  var oturum = oku(OTURUM_ANAHTAR, null); if (!oturum) { oturum = uuid(); yaz(OTURUM_ANAHTAR, oturum); }
  var mesajlar = oku(MESAJ_ANAHTAR, []);
  if (!Array.isArray(mesajlar)) mesajlar = [];
  mesajlar = mesajlar.filter(function (m) { return m && typeof m.metin === "string" && (m.rol === "bot" || m.rol === "musteri"); });

  var CIPLER = SABLON === "product"
    ? ["Ölçüleri nedir?", "Teslimat süresi ne kadar?", "Takım fiyatı nedir?"]
    : ["Köşe koltuklar", "Yemek odası takımları", "Teslimat ve kurulum"];

  // Yapay zekâ "parıltı" simgesi (WhatsApp düğmesi gibi yazısız, yuvarlak balon)
  var SIMGE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2 5.5 5.5 2-5.5 2-2 5.5-2-5.5L4.5 10 10 8l2-5.5z"/><path d="M19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9L19 14z"/><path d="M5 14.5l.7 1.9 1.9.7-1.9.7L5 19.7l-.7-1.9-1.9-.7 1.9-.7.7-1.9z"/></svg>';
  var WA_SIMGE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4 5.3 5.3 0 0 0 3.3.7 2.8 2.8 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>';

  kok.innerHTML =
    '<button class="rh-ac" type="button" aria-label="Yapay zekâ satış danışmanıyla sohbet" title="Yapay zekâ satış danışmanı">' + SIMGE + '</button>' +
    '<div class="rh-panel" role="dialog" aria-label="Satış danışmanı">' +
      '<div class="rh-bas">' + SIMGE + '<div><b>Rossohome Danışman</b><small>Ürün, ölçü, teslimat, kurulum</small></div><button type="button" aria-label="Kapat">×</button></div>' +
      '<div class="rh-liste" aria-live="polite"></div>' +
      '<div class="rh-cipler"></div>' +
      '<form class="rh-form"><input type="text" maxlength="500" placeholder="Mesajınızı yazın" aria-label="Mesajınız" autocomplete="off"><button type="submit" aria-label="Gönder">↑</button></form>' +
      '<div class="rh-not">Yapay zekâ destekli asistan · Konuşmalar hizmet kalitesi için saklanır</div>' +
    '</div>';

  var liste = kok.querySelector(".rh-liste"), cipler = kok.querySelector(".rh-cipler"), form = kok.querySelector(".rh-form"),
      giris = form.querySelector("input"), gonderDugme = form.querySelector("button"), acDugme = kok.querySelector(".rh-ac");

  function kacis(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function baglantila(s) { return kacis(s).replace(/https?:\/\/[^\s<]*[^\s<.,;:!?)]/g, function (u) { return '<a href="' + u + '" target="_blank" rel="noopener">' + u + "</a>"; }); }
  function kaydir() { liste.scrollTop = liste.scrollHeight; }
  function fiyat(kurus) { return (kurus / 100).toLocaleString("tr-TR", { maximumFractionDigits: 0 }) + " TL"; }
  function mesajlariSakla() { mesajlar = mesajlar.slice(-30); yaz(MESAJ_ANAHTAR, mesajlar); }

  var urunler = {};
  function urun(h) {
    return urunler[h] || (urunler[h] = fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }));
  }

  function mesajCiz(rol, metin) {
    metin = String(metin || "");
    var el = document.createElement("div");
    el.className = "rh-m " + rol;
    el.innerHTML = baglantila(metin);
    liste.appendChild(el);
    if (rol === "bot") {
      var handles = [];
      metin.replace(/https?:\/\/(?:www\.)?rossohome\.com\/products\/([a-z0-9-]+)/g, function (_, h) {
        if (handles.indexOf(h) < 0) handles.push(h);
        return _;
      });
      handles.slice(0, 3).forEach(function (h) {
        var yuva = document.createElement("div");
        liste.appendChild(yuva);
        kartCiz(h, yuva);
      });
    }
    kaydir();
  }

  function kartCiz(handle, yuva) {
    urun(handle).then(function (u) {
      if (!u) { yuva.remove(); return; }
      var k = document.createElement("div");
      k.className = "rh-kart";
      var varyantlar = u.variants || [];
      var v = varyantlar[0];
      var sepeteEklenebilir = varyantlar.length === 1 && !!v.available;
      var resim = u.featured_image ? u.featured_image + (u.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
      k.innerHTML = '<img src="' + kacis(resim) + '" alt="" loading="lazy">' +
        '<div><b>' + kacis(u.title) + '</b><span>' + fiyat(u.price) + '</span><div class="rh-ks"><a href="/products/' + kacis(handle) + '">İncele</a>' +
        (sepeteEklenebilir ? '<button type="button" class="birincil">Sepete ekle</button>' : "") + "</div></div>";
      var d = k.querySelector("button");
      if (d) d.addEventListener("click", function () {
        d.disabled = true;
        d.textContent = "Ekleniyor…";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function (r) {
            if (!r.ok) throw new Error("sepet");
            d.outerHTML = '<a href="/cart" class="birincil">Sepete eklendi · Sepete git</a>';
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          })
          .catch(function () {
            d.disabled = false;
            d.textContent = "Eklenemedi, tekrar deneyin";
          });
      });
      liste.replaceChild(k, yuva);
      kaydir();
    }).catch(function () { yuva.remove(); });
  }

  function waVarsayilan(sebep) {
    if (!WA) return "";
    return "https://wa.me/" + WA + "?text=" + encodeURIComponent("Merhaba, rossohome.com'daki asistanla görüşüyordum. Konu: " + sebep + ".");
  }
  function waDugme(url) {
    if (!/^https:\/\/wa\.me\//.test(url)) url = waVarsayilan("sitedeki asistan");
    if (!url) return;
    var a = document.createElement("a");
    a.className = "rh-wa";
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.innerHTML = WA_SIMGE + "<span>WhatsApp'tan devam et</span>";
    liste.appendChild(a);
    kaydir();
  }

  function ciplerCiz() {
    cipler.innerHTML = "";
    if (mesajlar.length) return;
    CIPLER.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "rh-cip";
      b.textContent = c;
      b.addEventListener("click", function () { gonder(c); });
      cipler.appendChild(b);
    });
  }

  function gonder(metin) {
    metin = (metin || "").trim();
    if (!metin || gonderDugme.disabled) return;
    mesajlar.push({ rol: "musteri", metin: metin });
    mesajlariSakla();
    mesajCiz("musteri", metin);
    ciplerCiz();
    giris.value = "";
    gonderDugme.disabled = true;
    var bekle = document.createElement("div");
    bekle.className = "rh-bekle";
    bekle.setAttribute("role", "status");
    bekle.textContent = "yazıyor…";
    liste.appendChild(bekle);
    kaydir();
    var govde = { oturum: oturum, metin: metin };
    if (SAYFA) govde.sayfa = { handle: SAYFA };
    var iptal = new AbortController();
    var zamanlayici = setTimeout(function () { iptal.abort(); }, 40000);
    fetch(URL_BOT + "/sohbet", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(govde), signal: iptal.signal })
      .then(function (r) {
        return r.json().then(
          function (j) { return { ok: r.ok, j: j }; },
          function () { return { ok: false, j: null }; }
        );
      })
      .then(function (s) {
        bekle.remove();
        if (!s.ok) {
          mesajCiz("bot", "Şu an cevap veremiyorum, dilerseniz WhatsApp'tan devam edelim.");
          waDugme((s.j && s.j.whatsappUrl) || waVarsayilan("sitedeki asistan cevap veremedi"));
          return;
        }
        (s.j.cevaplar || []).forEach(function (c) {
          mesajlar.push({ rol: "bot", metin: c });
          mesajCiz("bot", c);
        });
        if (s.j.aktarma && s.j.aktarma.whatsappUrl) waDugme(s.j.aktarma.whatsappUrl);
        mesajlariSakla();
      })
      .catch(function () {
        bekle.remove();
        mesajCiz("bot", "Bağlantı kurulamadı, dilerseniz WhatsApp'tan yazabilirsiniz.");
        waDugme(waVarsayilan("sitedeki asistana ulaşamadım"));
      })
      .then(function () {
        clearTimeout(zamanlayici);
        gonderDugme.disabled = false;
        if (kok.classList.contains("acik") && !mobilMi()) giris.focus();
      });
  }

  var cizildi = false;
  // Mobilde panel açıkken sitenin diğer yüzen düğmeleri (WhatsApp, Google rozeti) panelin üstüne binmesin
  var YUZENLER = "#carthike-chat-wrapper, #google-merchantwidget-iframe-wrapper";
  function yuzenleriGizle(gizle) {
    if (gizle && !window.matchMedia("(max-width: 600px)").matches) return;
    document.querySelectorAll(YUZENLER).forEach(function (el) {
      if (gizle) {
        if (!el.dataset.rhGizli) {
          el.dataset.rhGizli = el.style.visibility || "-";
          el.style.visibility = "hidden";
        }
      } else if (el.dataset.rhGizli) {
        el.style.visibility = el.dataset.rhGizli === "-" ? "" : el.dataset.rhGizli;
        delete el.dataset.rhGizli;
      }
    });
  }
  // Mobilde klavye kendiliğinden açılmasın; müşteri giriş alanına dokununca açılır
  function mobilMi() {
    return window.matchMedia("(max-width: 600px)").matches;
  }
  function ac(odakla) {
    kok.classList.add("acik");
    yuzenleriGizle(true);
    yaz(ACIK_ANAHTAR, true);
    if (!cizildi) {
      cizildi = true;
      mesajCiz("bot", kok.dataset.karsilama);
      mesajlar.forEach(function (m) { mesajCiz(m.rol, m.metin); });
      ciplerCiz();
    }
    if (odakla && !mobilMi()) giris.focus();
  }
  function kapat() {
    kok.classList.remove("acik");
    yuzenleriGizle(false);
    yaz(ACIK_ANAHTAR, false);
    acDugme.focus();
  }

  acDugme.addEventListener("click", function () { ac(true); });
  kok.querySelector(".rh-bas button").addEventListener("click", kapat);
  form.addEventListener("submit", function (e) { e.preventDefault(); gonder(giris.value); });
  kok.addEventListener("keydown", function (e) { if (e.key === "Escape" && kok.classList.contains("acik")) kapat(); });

  // Bot erişilemezse balon hiç görünmesin; sağlık sonucu 5 dk oturumda saklanır
  function goster() {
    kok.hidden = false;
    if (oku(ACIK_ANAHTAR, false) && mesajlar.length) ac(false);
  }
  var saglik = saglikOku();
  if (saglik && typeof saglik.zaman === "number" && Date.now() - saglik.zaman < SAGLIK_SURE) {
    if (saglik.ok) goster(); else kok.hidden = true;
  } else {
    fetch(URL_BOT + "/saglik")
      .then(function (r) {
        if (!r.ok) throw new Error("saglik");
        saglikYaz(true);
        goster();
      })
      .catch(function () {
        saglikYaz(false);
        kok.hidden = true;
      });
  }
})();
